module.exports = __webpack_public_path__ + "37b0a4a3c8f3a67bfab4f1f60f03f629.svg";